/* tslint:disable */
/* eslint-disable */
/**
 * AGAIN-AGAIN API
 * backend api for tracking container movement for again-again
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RapidOnboarding
 */
export interface RapidOnboarding {
    /**
     * 
     * @type {string}
     * @memberof RapidOnboarding
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RapidOnboarding
     */
    siteId: string;
}

export function RapidOnboardingFromJSON(json: any): RapidOnboarding {
    return RapidOnboardingFromJSONTyped(json, false);
}

export function RapidOnboardingFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapidOnboarding {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'siteId': json['site_id'],
    };
}

export function RapidOnboardingToJSON(value?: RapidOnboarding | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'site_id': value.siteId,
    };
}


